<template>
  <header>
    <h1><FontAwesomeIcon icon="clipboard-list" /> Todo List</h1>
  </header>
</template>

<script>
export default {};
</script>

<style scoped>
h1 {
  margin: 2.5rem 0 1.5rem;
  font-weight: 900;
  color: #2f3b52;
}
</style>
